import ContainedButton from "Components/HomeV2/Buttons/Contained";
import React from "react";
import { useForm } from "react-hook-form";

type FormData = {
  name: string;
  email: string;
};

export default function EbookFormSection({
  openForm,
}: {
  openForm: () => void;
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    console.log("Form Data:", data);
  };

  return (
    <section className="w-full bg-gradient-to-br  from-[#d8edff] to-[#c9e6ff] ">
      <div className="max-w-[1400px] mx-auto px-6  mt-10 flex flex-col md:flex-row  justify-between gap-10">
        <div className="w-full md:max-w-md">
          <h2 className="lg:text-[3.5rem] text-[2rem] text-center lg:text-start text-black  font-bold mb-6 leading-tight">
            Get a <span className="text-[#84CC16]">FREE</span> <br />
            Copy of our Ebook
          </h2>

          <ContainedButton
            size="lg"
            className="px-10"
            theme="primary"
            onClick={() => openForm()}
          >
            <span className="flex lg:px-4 py-2 items-center gap-2 text-white">
              Book a Demo
            </span>
          </ContainedButton>

          {/* <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <input
                type="text"
                placeholder="Full Name*"
                {...register("name", { required: "Name is required" })}
                className="w-full px-5 py-3 rounded-full bg-white placeholder-gray-400 outline-none focus:ring-2 focus:ring-green-500"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.name.message}
                </p>
              )}
            </div>

            <div>
              <input
                type="email"
                placeholder="Email Address*"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^\S+@\S+$/i,
                    message: "Invalid email address",
                  },
                })}
                className="w-full px-5 py-3 rounded-full bg-white placeholder-gray-400 outline-none focus:ring-2 focus:ring-green-500"
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>
          </form> */}
        </div>

        <div className="w-full max-w-[400px]  -mb-44 lg:-mb-20">
          <img src="/ebook.png" alt="Ebook Cover" className="w-full h-full " />
        </div>
      </div>
      <div className="bg-white w-full h-44 lg:h-20"></div>
    </section>
  );
}
